import { motion, HTMLMotionProps } from 'framer-motion';

const animateFunc = (
  animationProps: Pick<HTMLMotionProps<'div'>, 'initial' | 'animate' | 'exit'>
) => {
  const comp = (props: HTMLMotionProps<'div'>) => {
    return (
      <motion.div
        initial={animationProps.initial}
        animate={animationProps.animate}
        exit={animationProps.exit}
        {...props}
      >
        {props.children}
      </motion.div>
    );
  };

  return comp;
};

const AnimatedDiv = {
  TopToBottomWithOpacity: animateFunc({
    initial: { opacity: 0.6, y: 10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0.6, y: 10 },
  }),
  BottomToTopWithOpacity: animateFunc({
    initial: { opacity: 0.6, y: -10 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0.6, y: 10 },
  }),
  Opacity: animateFunc({
    initial: { opacity: 0.5 },
    animate: { opacity: 1 },
    exit: { opacity: 0.5 },
  }),
  ZoomInWithOpacity: animateFunc({
    initial: { opacity: 0.6, scale: 0.96 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0.6, scale: 0.96 },
  }),
};

export default AnimatedDiv;
